"use client"

import { LogIn, Shield, UserPlus } from "lucide-react"
import Link from "next/link"
import { useRouter } from "next/navigation"
import { useEffect } from "react"

import { Button } from "#/components/ui/button"
import { authClient } from "#/lib/auth/client"

export default function Home() {
  const { session, isPending } = authClient.useSession()
  const router = useRouter()

  useEffect(() => {
    // If user is already logged in, redirect to feed
    if (!isPending && session) {
      router.push("/feed")
    }
  }, [session, isPending, router])

  if (isPending) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600 mx-auto mb-4"></div>
          <p>Loading...</p>
        </div>
      </div>
    )
  }

  // Don't render if user is logged in (will redirect)
  if (session) {
    return null
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-50 to-slate-100">
      <div className="text-center space-y-6 max-w-md mx-auto p-6">
        <div className="mx-auto w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center">
          <Shield className="h-10 w-10 text-blue-600" />
        </div>
        <h1 className="text-4xl font-bold text-slate-900">Social Signal</h1>
        <p className="text-slate-600 text-lg">
          Privacy-first social media platform with end-to-end encryption and
          complete user control
        </p>
        <div className="space-y-3">
          <Link href="/signup">
            <Button className="w-full bg-blue-600 hover:bg-blue-700 flex items-center gap-2">
              <UserPlus className="h-4 w-4" />
              Create Account
            </Button>
          </Link>
          <Link href="/signin">
            <Button
              variant="outline"
              className="w-full bg-transparent flex items-center gap-2"
            >
              <LogIn className="h-4 w-4" />
              Sign In
            </Button>
          </Link>
        </div>

        {/* Feature highlights */}
        <div className="mt-8 space-y-3 text-sm text-slate-600">
          <div className="flex items-center gap-2">
            <Shield className="h-4 w-4 text-green-600" />
            <span>End-to-end encryption</span>
          </div>
          <div className="flex items-center gap-2">
            <Shield className="h-4 w-4 text-green-600" />
            <span>Maximum privacy by default</span>
          </div>
          <div className="flex items-center gap-2">
            <Shield className="h-4 w-4 text-green-600" />
            <span>Complete user control</span>
          </div>
          <div className="flex items-center gap-2">
            <Shield className="h-4 w-4 text-green-600" />
            <span>100% Open Source</span>
          </div>
          <div className="flex items-center gap-2">
            <Shield className="h-4 w-4 text-green-600" />
            <span>Only you and those who follow you can see your posts</span>
          </div>
        </div>
      </div>
    </div>
  )
}
